var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F9FAFB",
  fillRule: "evenodd",
  d: "M63 134h91q.774-.002 1.5-.161.726.16 1.5.161h52a7 7 0 1 0 0-14h-6a7 7 0 1 1 0-14h19a7 7 0 1 0 0-14h-22a7 7 0 1 0 0-14h-64a7 7 0 1 0 0-14H79a7 7 0 1 0 0 14H39a7 7 0 1 0 0 14h25a7 7 0 1 1 0 14H24a7 7 0 1 0 0 14h39a7 7 0 1 0 0 14m163 0a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M169 110.333v29.334a11 11 0 0 1-11 11H92a11 11 0 0 1-11-11V81a11 11 0 0 1 11-11h66a11 11 0 0 1 11 11v29.333"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#374151",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M169 110.333a11 11 0 0 0-11-11h-18.333a14.668 14.668 0 0 1-29.334 0H92a11 11 0 0 0-11 11m88 0v29.334a11 11 0 0 1-11 11H92a11 11 0 0 1-11-11v-29.334m88 0V95.667m-88 14.666V95.667m88 0a11 11 0 0 0-11-11H92a11 11 0 0 0-11 11m88 0V81a11 11 0 0 0-11-11H92a11 11 0 0 0-11 11v14.667"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#9CA3AF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M150.1 46.303 139 58.756M124.1 42v16.756zM98 46.303l11.1 12.453zM91 140.743v-18.318m0-5.682V112z"
})));
export default SvgWallet;